// ContextProvider.js
import React, { createContext, useContext, useState } from "react";
import { Outlet } from "react-router-dom";
const BarcodeContext = createContext();

export const BarcodeProvider = ({ children }) => {
  const [data, setData] = useState();
  const [aboveLabel, setAboveLabel] = useState();
  const [belowLabel, setBelowLabel] = useState();
  return (
    <BarcodeContext.Provider
      value={{
        data,
        setData,
        belowLabel,
        aboveLabel,
        setAboveLabel,
        setBelowLabel,
      }}
    >
      {children}
    </BarcodeContext.Provider>
  );
};

export const useData = () => useContext(BarcodeContext);
